import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
    selector: 'warema-pdf-viewer',
    imports: [NgxExtendedPdfViewerModule],
    templateUrl: './pdf-viewer.component.html',
    styleUrl: './pdf-viewer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerComponent {
    public readonly showPrintButton = input<boolean>(true);

    public readonly src = input.required<string | ArrayBuffer | Blob | Uint8Array | URL>();

    public readonly filenameForDownload = input.required<string>();
    public readonly trackScrolling = input<boolean>(false);
    public readonly scrolledToBottom = output<void>();

    public readonly translateService = inject(TranslateService);

    public pagesCount = 0;

    public onPageLoaded(pagesCount: number): void {
        if (pagesCount === 1) {
            this.scrolledToBottom.emit();
        }
        this.pagesCount = pagesCount;
    }
}
